<div class="locationGridCell" *ngrxLet="viewModel$; let model">
  @if (model.subtype === linkCellSubtype.SINGLE_LINK) {
    @if (!model.loading) {
      <a href="{{ model.value | prependProtocol }}"
         target="_blank"
         rel="noopener noreferrer"
         (click)="trackLinkClick(model.fieldName)"
         [ngClass]="{ 'text-neutral-60': model.isFieldBlacklisted }">
        <span>{{model.value}}</span>
      </a>
    }
    @if (model.loading) {
      <ngx-skeleton-loader class="w-full"
                           [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
    }
  }

  @if (model.subtype === linkCellSubtype.MULTIPLE_LINKS) {
    <div class="flex flex-col">
<!--      edge case when there are no links originally, render at least 1 loader -->
      @if (!model.value?.length && model.loading) {
        <ngx-skeleton-loader class="w-full"
                             [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
      }

      @for (singleLink of (model.value | split); track singleLink) {
        @if (!model.loading) {
          <a href="{{ singleLink | prependProtocol }}"
             target="_blank"
             rel="noopener noreferrer"
             [ngClass]="{ 'text-neutral-60': model.isFieldBlacklisted }"
             (click)="trackLinkClick(model.fieldName)">
            <span>{{ singleLink }}</span>
          </a>
        }
<!--        render loader for each link -->
        @if (model.loading) {
          <ngx-skeleton-loader class="w-full"
                               [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
        }
      }
    </div>
  }
</div>
